import axios from "axios";
// Base URL: https://api.themoviedb.org/3/
//URL DA API: https://api.themoviedb.org/3/movie/now_playing?api_key=1b8ec1097e7218689858516cbab094dc&language=pt-BR

const api = axios.create({
  baseURL: "https://api.themoviedb.org/3/"
});

export default api;